/* eslint-disable tailwindcss/enforces-negative-arbitrary-values */
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";

export function ActiveEmptyStateContainer({
    title,
    description,
    children,
}: {
    title: string;
    description: string;
    children: React.ReactNode;
}) {
    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1.5, ease: "easeInOut" }}
                className="flex size-full items-center justify-center"
            >
                <div
                    className={clsx(
                        "max-w-[700px]",
                        "flex flex-col",
                        "mt-[20%] h-full gap-9",
                    )}
                >
                    <div className="flex flex-col gap-2.5">
                        <h1 className="display-m">{title}</h1>
                        <p className="body-m subdued">{description}</p>
                    </div>

                    {children}
                </div>
            </motion.div>
        </AnimatePresence>
    );
}
